'use client'

import React, { useRef } from 'react'
import { Box, HStack } from '@chakra-ui/react'
import { ICategory } from '@/app/[locale]/_types'
import CategoryLink from './Link'
import MoreBtn from './Link/components/MoreBtn'

import Filters from './Filters'

interface IProps {
  data: ICategory[] | undefined
  active?: ICategory
  showImage: boolean
  hasFilter?: boolean
  count?: number | string
  hasNextPage?: boolean
  fetchNextPage?: () => void
  isFetchingNextPage?: boolean
  isSeperatePage?: boolean
}

function StaticBar({
  data,
  count,
  hasFilter = true,
  showImage = true,
  hasNextPage,
  fetchNextPage,
  isSeperatePage,
  isFetchingNextPage,
}: IProps) {
  const catalogRef = useRef<any>(null)
  return (
    <>
      <HStack
        gap={{ base: 0, lg: 4 }}
        maxWidth='100%'
        ref={catalogRef}
        pt={{ base: 4, md: 8 }}
        flexWrap={{ base: 'nowrap', md: 'wrap' }}
        overflowX={{ base: 'auto', md: 'visible' }}
        scrollbar={'hidden'}
        align='stretch'
      >
        <Box>{hasFilter && <Filters />}</Box>
        {data?.map((item, idx) => (
          <CategoryLink
            category={item}
            showImage={showImage}
            key={`${item.id}-${item.slug}-${idx}`}
            isSeperatePage={isSeperatePage}
          />
        ))}
        <MoreBtn
          data={data || []}
          count={count}
          showImage={showImage}
          hasNextPage={hasNextPage}
          fetchNextPage={fetchNextPage}
          isFetchingNextPage={isFetchingNextPage}
        />
      </HStack>
    </>
  )
}

export default StaticBar
